import { Box } from '@mui/material';
import { FC } from 'react';

import useScheduleListViewHeader from './hooks/useScheduleListViewHeader';
import Button from 'components/Button/Button';
import Typography from 'components/Typography/Typography';

const ScheduleListViewHeader: FC = () => {
  const { handleCloseScheduleListView } = useScheduleListViewHeader();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" m={4}>
      <Box>
        <Typography variant="h4" weight="bold">
          All Schedule Tickets
        </Typography>
      </Box>
      <Box>
        <Button size="md" variant="contained" onClick={handleCloseScheduleListView}>
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default ScheduleListViewHeader;
